import React, { useEffect, useState } from "react";
import { api, formatDateTime } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Badge } from "../components/ui/badge";
import { Plus, Check, Trash2 } from "lucide-react";
import { toast } from "sonner";

const empty = { title:"", company:"", type:"call", date:"", notes:"" };
const STATUS_CLS = {
  today: "bg-amber-50 text-amber-800 border-amber-200",
  upcoming: "bg-blue-50 text-blue-700 border-blue-200",
  overdue: "bg-rose-50 text-rose-700 border-rose-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-slate-100 text-slate-700 border-slate-200",
};

export default function FollowUp() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("all");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);

  const load = async () => {
    const r = await api.get("/followups", { params: { status: tab } });
    setItems(r.data);
  };
  useEffect(() => { load(); }, [tab]);

  const save = async () => {
    try {
      await api.post("/followups", { ...form, date: form.date || new Date().toISOString() });
      toast.success("Follow-up dijadwalkan"); setOpen(false); setForm(empty); load();
    } catch { toast.error("Gagal menyimpan"); }
  };
  const complete = async (id) => { await api.post(`/followups/${id}/complete`); toast.success("Selesai"); load(); };
  const del = async (id) => { if(!window.confirm("Hapus?"))return; await api.delete(`/followups/${id}`); load(); };

  return (
    <div className="space-y-5" data-testid="followup-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold" style={{fontFamily:"Outfit"}}>Follow-up</h1>
          <p className="text-sm text-slate-500">Jangan lewatkan momentum sales Anda.</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="brand-btn" data-testid="add-followup-btn"><Plus className="w-4 h-4 mr-1"/>Follow-up Baru</Button></DialogTrigger>
          <DialogContent className="max-w-lg">
            <DialogHeader><DialogTitle>Follow-up Baru</DialogTitle></DialogHeader>
            <div className="grid grid-cols-2 gap-3 py-2">
              <div className="col-span-2"><Label>Judul</Label><Input data-testid="followup-title" value={form.title} onChange={(e)=>setForm({...form,title:e.target.value})}/></div>
              <div><Label>Perusahaan</Label><Input value={form.company} onChange={(e)=>setForm({...form,company:e.target.value})}/></div>
              <div><Label>Tipe</Label>
                <Select value={form.type} onValueChange={(v)=>setForm({...form,type:v})}>
                  <SelectTrigger><SelectValue/></SelectTrigger>
                  <SelectContent>{["call","whatsapp","email","meeting","demo"].map(s=><SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                </Select>
              </div>
              <div className="col-span-2"><Label>Tanggal & Waktu</Label><Input type="datetime-local" value={form.date} onChange={(e)=>setForm({...form,date:e.target.value})}/></div>
              <div className="col-span-2"><Label>Catatan</Label><Input value={form.notes} onChange={(e)=>setForm({...form,notes:e.target.value})}/></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={()=>setOpen(false)}>Batal</Button><Button className="brand-btn" onClick={save} data-testid="followup-save">Simpan</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <Card className="p-4">
        <Tabs value={tab} onValueChange={setTab} className="mb-4">
          <TabsList>
            <TabsTrigger value="all" data-testid="fu-tab-all">Semua</TabsTrigger>
            <TabsTrigger value="today" data-testid="fu-tab-today">Hari Ini</TabsTrigger>
            <TabsTrigger value="upcoming" data-testid="fu-tab-upcoming">Akan Datang</TabsTrigger>
            <TabsTrigger value="overdue" data-testid="fu-tab-overdue">Terlambat</TabsTrigger>
            <TabsTrigger value="completed" data-testid="fu-tab-completed">Selesai</TabsTrigger>
          </TabsList>
        </Tabs>

        <div className="space-y-3">
          {items.map((f)=>(
            <div key={f.id} className="flex items-center gap-3 p-3 rounded-lg border border-slate-200 hover:bg-slate-50" data-testid={`fu-row-${f.id}`}>
              <div className={`w-2 self-stretch rounded-full ${STATUS_CLS[f.computed_status]?.split(" ")[0] || "bg-slate-200"}`}/>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-semibold text-slate-800">{f.title}</span>
                  <Badge className={`badge-status ${STATUS_CLS[f.computed_status] || ""}`}>{f.computed_status}</Badge>
                  <Badge variant="outline" className="capitalize text-[10px]">{f.type}</Badge>
                </div>
                <div className="text-xs text-slate-500 mt-0.5">{f.company} · {formatDateTime(f.date)}</div>
              </div>
              {f.status !== "completed" && (
                <button onClick={()=>complete(f.id)} className="text-emerald-700 hover:text-emerald-900" title="Selesai" data-testid={`fu-complete-${f.id}`}>
                  <Check className="w-5 h-5"/>
                </button>
              )}
              <button onClick={()=>del(f.id)} className="text-slate-300 hover:text-rose-500"><Trash2 className="w-4 h-4"/></button>
            </div>
          ))}
          {items.length === 0 && <div className="text-center py-8 text-slate-500">Tidak ada follow-up.</div>}
        </div>
      </Card>
    </div>
  );
}
